import AppRouter from "./lib/routes/AppRouter";
import "./lib/styles/global.scss";
import { SnackbarProvider } from "notistack";
import { ErrorSnack } from "./lib/components/Snackbar";
import { SnackbarUtilsConfigurator } from "./lib/components/Snackbar/utils";
import Highcharts from "highcharts/highstock";
import StyledMaterialDesignContent from "./lib/components/Snackbar/styledMaterialDesignContent";

Highcharts.setOptions({
  time: {
    useUTC: false,
  },
});

function App() {
  return (
    <SnackbarProvider
      maxSnack={5} // Allow 5 notifications to stack
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        enphaseError: ErrorSnack, // Register your custom variant name
      }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
    >
      <SnackbarUtilsConfigurator />
      <AppRouter />
    </SnackbarProvider>
  );
}

export default App;
